import { render } from "./FattureFornitoreSottoProgetto.vue?vue&type=template&id=4b7f6cbe&scoped=true&ts=true"
import script from "./FattureFornitoreSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./FattureFornitoreSottoProgetto.vue?vue&type=script&lang=ts"

import "./FattureFornitoreSottoProgetto.vue?vue&type=style&index=0&id=4b7f6cbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7f6cbe"]])

export default __exports__